import React, { FC } from 'react'
import { Alert } from 'react-bootstrap'

export type errorHandlerType = {
  message: string
  level?: string
  statuscode?: number
  forceable?: boolean
}

const ErrorMessageContainer: FC<{ error: errorHandlerType | null; show: boolean; onClose: () => void }> = ({ error, show, onClose }) => {
  const errorMessage = getErrorMessage(error)
  return (
    <Alert variant={errorMessage?.level === 'WARNING' ? 'warning' : 'danger'} className='my-auto' show={show} onClose={onClose} dismissible>
      {errorMessage?.message}
    </Alert>
  )
}

function getErrorMessage(errorMessage: errorHandlerType | string | null): errorHandlerType | null {
  if (typeof errorMessage === 'string') {
    return { message: errorMessage }
  } else if (errorMessage instanceof Blob) {
    const reader = new FileReader()
    reader.onload = function () {
      if (typeof this.result === 'string') {
        return JSON.parse(this.result)
      }
    }
    reader.readAsText(errorMessage)
  }
  return errorMessage
}

export function closeErrorAlert(setError: React.Dispatch<any>, setShowError: React.Dispatch<React.SetStateAction<boolean>>) {
  return () => {
    setError(null)
    setShowError(false)
  }
}

export default ErrorMessageContainer
